<script>
import ListingResource from '../resources/listing'
import ProfileCell from '../components/ProfileCell.vue'

export default {
    name: 'JobApplyButton',
    components: {
        ProfileCell
    },
    mixins: [],
    props: {
        listingResource: {
            required: true,
            type: ListingResource
        },
        size: {
            type: String,
            default: 'lg'
        },
        text: {
            type: String,
            default: 'Apply to This Job'
        },
        variant: {
            type: String,
            default: 'primary'
        },
        noRedirect: Boolean
    },
    data() {
        return {
            loading: false,
            applyModalVisible: false,
            successModalVisible: false,
            profileResource: null
        }
    },
    methods: {
        async onClick() {
            let userResource = this.$store.getters.userResource

            if(userResource) {
                this.profileResource = await userResource.getProfile()

                if(this.profileResource) {
                    this.applyModalVisible = true
                } else {
                    this.redirectToSignup()
                }
            } else {
                this.redirectToSignup()
            }
        },
        async onOk() {
            try {
                await this.listingResource.apply()
                this.applyModalVisible = false
                this.successModalVisible = true
            } catch(e) {
                this.addError(this.parseAPIErrorsOrRethrow(e))
            }
        },
        redirectToSignup() {
            this.$router.push({ name: 'signupDeveloper' })
        }
    },
    mounted() {
        
    }
}
</script>

<template>
    <div>
        <b-button :variant="variant" :size="size" @click="onClick">{{ text }}</b-button>

        <b-modal :title="`Apply to ${listingResource}`" v-model="applyModalVisible" size="lg" ok-title="Send Application" @ok="onOk" no-fade centered>
            <profile-cell :profile="profileResource" />
        </b-modal>

        <b-modal title="Application Sent!" v-model="successModalVisible" ok-title="Done" ok-only no-fade centered>
            <b-alert variant="success" show>You've successfully applied to <strong>{{ listingResource }}</strong> at {{ listingResource.get('company.name') }}.</b-alert>
        </b-modal>
    </div>
</template>

<style lang="scss">
</style>
